module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAENSURBVHgB7VO7cQJBDH0SFzrYDnwl0AHjChzZscfOcQnYFfibAk5tIndgVwB0sHSwASEnIXEcnxkiNiHgzdys9vbtk3b0RC/DYShw8UigUkUCiIJCSxjsX7DFv10kO0/r87haiaKI/Hcfbr/orf/9xMQ9NSKMaCQnJyglYiQcgGqd0JOZePBifCMqz4WJdSz+697fXCEDn4PRmJmu2eK2l4xMVJCpvap0wVBJNUMuFNG1XDC1uHWJXBBK12ICokLayASDvahJUan82qb3MRipdSxuuozaDocuN/bCtsur2LtMTnjv/9wxc6exQ+NDkzTyvg8be9WvtIRre6nobMHzV5w86Dx6R+M8eic8ekt+M9Jt+Mr5HAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sidebar-icons/product-disable.png
// module id = SGG3
// module chunks = 37